<template>
  <div class="bracket">
    <h5 class="text-white pt-0">{{ $t('Please click on the Left or the Right to select.') }} </h5>

    <!-- The First Choices -->
    <transition name="fade" mode="in-out">
      <div class="flex flex-wrap items-center flex-col-reverse md:flex-col" v-if="bracket.length >= 3">
        <div class="bracket-wrapper py-3">
          <div class="bracket-responsive">

            <!-- First Item -->
            <button class="bracket-item bracket-item__first mb-1 mr-1 relative cursor-pointer"
              @click="(leftChosen = !leftChosen), (rightChosen = false)"
              :class="{active: leftChosen}"
              :aria-label="bracket[0].attributes.title.text"
              aria-describedby="description_left"
              :aria-pressed="leftChosen ? true : false"
              type="button"
            >
              <div class="bracket-item-center">
                <div class="attributes">
                    <div class="attributes-rows">
                      <h2 class="title stylebr pt-0" v-html="bracket[0].attributes.title.text"></h2>

                      <div class="description stylebr">
                          <img v-if="bracket[0].attributes.image" :src="bracket[0].attributes.image.text" :alt="bracket[0].attributes.title.text" class="image"/>

                          <span id="description_left" v-html="brToLi(bracket[0].attributes.description.text)"></span>

                          <button
                            v-if="bracket[0].attributes['showmore']"
                            id="modal_first"
                            class="showmore"
                            type="button"
                            @click.stop="showModal('first')"
                            :aria-label="$t('More information about option: {option}', {option: bracket[0].attributes.title.text})"
                          >
                            <i aria-hidden="true" class="material-icons">read_more</i><i aria-hidden="true" class="material-icons">menu_book</i>
                          </button>

                          <card-modal ref="modal_first" v-if="bracket[0].attributes['showmore']">
                            <span v-html="bracket[0].attributes['showmore'].text"></span>
                          </card-modal>
                        </div>
                    </div>
                </div>
              </div>
            </button>

            <!-- Second Item -->
            <button class="bracket-item mb-1 mr-0 relative cursor-pointer"
              @click="(rightChosen = !rightChosen), (leftChosen = false)"
              :class="{active: rightChosen}"
              :aria-label="bracket[1].attributes.title.text"
              aria-describedby="description_right"
              :aria-pressed="rightChosen ? true : false"
              type="button"
            >
              <div class="bracket-item-center">
                <div class="attributes">
                    <div class="attributes-rows">
                      <h2 class="title stylebr pt-0" v-html="bracket[1].attributes.title.text"></h2>

                      <div class="description stylebr">
                          <img v-if="bracket[1].attributes.image" :src="bracket[1].attributes.image.text" :alt="bracket[1].attributes.title.text" class="image"/>

                          <span id="description_right" v-html="brToLi(bracket[1].attributes.description.text)"></span>

                          <button
                            v-if="bracket[1].attributes['showmore']"
                            id="modal_second"
                            class="showmore"
                            type="button"
                            @click.stop="showModal('second')"
                            :aria-label="$t('More information about option: {option}', { option: bracket[1].attributes.title.text})"
                          >
                            <i aria-hidden="true" class="material-icons">read_more</i><i aria-hidden="true" class="material-icons">menu_book</i>
                          </button>

                          <card-modal ref="modal_second" v-if="bracket[1].attributes['showmore']">
                            <span v-html="bracket[1].attributes['showmore'].text"></span>
                          </card-modal>
                        </div>
                    </div>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- The Final Choice -->
    <transition name="fade" mode="in-out">
      <div class="flex flex-wrap items-center flex-col-reverse md:flex-col" v-if="bracket.length < 3">
        <div class="bracket-wrapper py-3">
          <div class="bracket-responsive">

            <!-- First Item -->
            <button class="bracket-item bracket-item__first mb-1 mr-1 relative cursor-pointer"
              @click="(leftChosen = !leftChosen), (rightChosen = false)"
              :class="{active: leftChosen}"
              :aria-label="bigwinnersarray[0].attributes.title.text"
              aria-describedby="winner_description_left"
              :aria-pressed="leftChosen ? true : false"
              type="button"
            >
              <div class="bracket-item-center">
                <div class="attributes">
                    <div class="attributes-rows">
                      <h2 class="title stylebr pt-0" v-html="bigwinnersarray[0].attributes.title.text"></h2>

                      <div class="description stylebr">
                          <img v-if="bigwinnersarray[0].attributes.image" :src="bigwinnersarray[0].attributes.image.text" :alt="bigwinnersarray[0].attributes.title.text" class="image"/>

                          <span id="winner_description_left" v-html="bigwinnersarray[0].attributes.description.text"></span>

                          <button
                            v-if="bigwinnersarray[0].attributes['showmore']"
                            id="modal_first"
                            class="showmore"
                            type="button"
                            @click.stop="showModal('first')"
                            :aria-label="$t('More information about option: {option}', { option: bigwinnersarray[0].attributes.title.text })"
                          >
                            <i aria-hidden="true" class="material-icons">read_more</i><i aria-hidden="true" class="material-icons">menu_book</i>
                          </button>

                          <card-modal ref="modal_first" v-if="bigwinnersarray[0].attributes['showmore']">
                            <span v-html="bigwinnersarray[0].attributes['showmore'].text"></span>
                          </card-modal>
                        </div>
                    </div>
                </div>
              </div>
            </button>

            <!-- Second Item -->
            <button class="bracket-item mb-1 mr-0 relative cursor-pointer"
              @click="(rightChosen = !rightChosen), (leftChosen = false)"
              :class="{active: rightChosen}"
              :aria-label="bigwinnersarray[1].attributes.title.text"
              aria-describedby="winner_description_right"
              :aria-pressed="rightChosen ? true : false"
              type="button"
            >
              <div class="bracket-item-center">
                <div class="attributes">
                    <div class="attributes-rows">
                      <h2 class="title stylebr pt-0" v-html="bigwinnersarray[1].attributes.title.text"></h2>

                      <div class="description stylebr">
                          <img v-if="bigwinnersarray[1].attributes.image" :src="bigwinnersarray[1].attributes.image.text" :alt="bigwinnersarray[1].attributes.title.text" class="image"/>

                          <span if="winner_description_right" v-html="bigwinnersarray[1].attributes.description.text"></span>

                          <button
                            v-if="bigwinnersarray[1].attributes['showmore']"
                            id="modal_second"
                            class="showmore"
                            type="button"
                            @click.stop="showModal('second')"
                            :aria-label="$t('More information about option: {option}', { option: bigwinnersarray[1].attributes.title.text})"
                          >
                            <i aria-hidden="true" class="material-icons">read_more</i><i aria-hidden="true" class="material-icons">menu_book</i>
                          </button>

                          <card-modal ref="modal_second" v-if="bigwinnersarray[1].attributes['showmore']">
                            <span v-html="bigwinnersarray[1].attributes['showmore'].text"></span>
                          </card-modal>
                        </div>
                    </div>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Choosing before it's the final two -->
    <div class="submit-button-wrapper z-50 mt-4" v-if="bracket.length >= 3">
        <div aria-live="polite">
          <transition name="fade" mode="in-out">
            <div v-if="leftChosen">
              <input type="hidden" name="selectThisLeft" :value="bracket[0].id">
              <button v-if="bracket[0]" id="selectThisLeft" @click="selectThis(bracket[0], bracket[1], bracket[1].id, bracket[0].id),(leftChosen = false), (rightChosen = false)" type="submit" class="centerit px-5 py-2">Choose {{ bracket[0].attributes['title'].text }}<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
            </div>
          </transition>
        </div>

        <div aria-live="polite">
          <transition name="fade" mode="in-out">
            <div v-if="rightChosen">
              <input type="hidden" name="selectThisRight" :value="bracket[1].id">
              <button v-if="bracket[1]" id="selectThisRight" @click="(selectThis(bracket[1], bracket[0], bracket[0].id, bracket[1].id)),(leftChosen = false), (rightChosen = false)" type="submit" class="centerit px-5 py-2">Choose {{ bracket[1].attributes['title'].text }}<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
            </div>
          </transition>
        </div>
    </div>

    <!-- Choosing the final two -->
    <div class="submit-button-wrapper z-50 mt-4" v-if="bracket.length <= 2">
        <div aria-live="polite">
          <transition name="fade" mode="in-out">
            <div v-if="leftChosen">
              <input type="hidden" name="selectThisLeft" :value="bigwinnersarray[0].id">
              <button id="selectThisLeft" @click="selectThis(bigwinnersarray[0], bigwinnersarray[1], bigwinnersarray[1].id, bigwinnersarray[0].id),(leftChosen = false), (rightChosen = false)" type="submit" class="centerit px-5 py-2">
                <template v-if="demo == 1"> {{ $t('Restart Demo') }} </template>
                <template v-else>
                {{ $t('Choose') }} {{ bigwinnersarray[0].attributes['title'].text }}</template>
                <i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
            </div>
          </transition>
        </div>

        <div aria-live="polite">
          <transition name="fade" mode="in-out">
            <div v-if="rightChosen">
              <input type="hidden" name="selectThisRight" :value="bigwinnersarray[1].id">
              <button id="selectThisRight" @click="(selectThis(bigwinnersarray[1], bigwinnersarray[0], bigwinnersarray[0].id, bigwinnersarray[1].id)),(leftChosen = false), (rightChosen = false)" type="submit" class="centerit px-5 py-2">
                <template v-if="demo == 1"> {{ $t('Restart Demo') }} </template>
                <template v-else>
                {{ $t('Choose') }} {{ bigwinnersarray[1].attributes['title'].text }}</template>
                <i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
            </div>
          </transition>
        </div>
    </div>

    <div class="">
      <div class="tournament-brackets">
        <div class="block">
          <transition name="fade" mode="in-out">
            <div class="quarter-bracket" v-if="this.winnersarray.length < 3">
              <ul class="round round-4" :aria-label="$t('First round choices')">
                <span :aria-label="$t('First choose between:')">
                  <li class="match">
                    <div class="match__content">
                      {{ data[0].attributes.title.text }}
                    </div>
                  </li>

                  <li class="match">
                    <div class="match__content">
                      {{ data[1].attributes.title.text }}
                    </div>
                  </li>
                </span>

                <span :aria-label="$t('And then choose between:')">
                  <li class="match">
                    <div class="match__content">
                      {{ data[2].attributes.title.text }}
                    </div>
                  </li>

                  <li class="match">
                    <div class="match__content">
                      {{ data[3].attributes.title.text }}
                    </div>
                  </li>
                </span>
              </ul>

              <ul class="round round-2" :aria-label="$t('Second round choices. Choose between your two first round choices:')">
                <li class="match">
                  <div class="match__content">
                    <span v-if="winnersarray.length > 0">
                    {{ winnersarray[0].attributes.title.text }}
                    </span>
                  </div>
                </li>

                <li class="match">
                  <div class="match__content">
                    <span v-if="winnersarray.length > 1">
                    {{ winnersarray[1].attributes.title.text }}
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            <div class="quarter-bracket" v-else-if="this.winnersarray.length === 3 || this.winnersarray.length === 4 || this.winnersarray.length === 5">
              <ul class="round round-4" :aria-label="$t('First round choices')">
                <span :aria-label="$t('First choose between:')">
                  <li class="match">
                    <div class="match__content">
                      {{ data[4].attributes.title.text }}
                    </div>
                  </li>

                  <li class="match">
                    <div class="match__content">
                      {{ data[5].attributes.title.text }}
                    </div>
                  </li>
                </span>

                <span :aria-label="$t('And then choose between:')">
                  <li class="match">
                    <div class="match__content">
                      {{ data[6].attributes.title.text }}
                    </div>
                  </li>

                  <li class="match">
                    <div class="match__content">
                      {{ data[7].attributes.title.text }}
                    </div>
                  </li>
                </span>
              </ul>

              <ul class="round round-2" :aria-label="$t('Second round choices. Choose between your two first round choices:')">
                <li class="match">
                  <div class="match__content">
                    <span v-if="winnersarray.length > 3">
                    {{ winnersarray[3].attributes.title.text }}
                    </span>
                  </div>
                </li>

                <li class="match">
                  <div class="match__content">
                    <span v-if="winnersarray.length > 4">
                    {{ winnersarray[4].attributes.title.text }}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import brToLi from '../../mixins/br-to-li.js'

export default {
  mixins: [brToLi],

  props: {
      array: '',
      route: '',
      demo:'',
  },
  data () {
    return {
      leftChosen: false,
      rightChosen: false,
      hidebracket: true,
      bracket: this.array.slice(0),
      data: this.array,
      finalarray: [],
      submitarray: [],
      winnersarray: [],
      bigwinnersarray: [],
    }
  },
  methods: {
    showModal(ID) {
      let modal_id = "modal_" + ID;
      this.$refs[modal_id].show();
    },
    selectThis(winner, loser, loserid, winnerid){
        this.finalarray.push(loser);
        this.submitarray.push(loserid);
        this.winnersarray.push(winner);
        this.bracket.splice(winner, 1);
        this.bracket.splice(loser, 1);
        if (this.bracket.length === 6)
          this.bracket.splice(2, 0, winner);
        else if (this.bracket.length === 5)
          this.bracket.splice(1, 0, winner);
        else if (this.bracket.length === 4)
          this.bracket.push(winner),
          this.bigwinnersarray.push(winner);
        else if (this.bracket.length === 3)
          this.bracket.splice(2, 0, winner);
        else if (this.bracket.length === 2)
          this.bracket.splice(1, 0, winner);
        else if (this.bracket.length === 1)
          this.bracket.splice(2, 0, winner),
          this.bigwinnersarray.push(winner);
        else if (this.demo == 1)
          this.restartBracket();
        else
          this.submitarray.push(winnerid),
          this.submitFinal();
        console.log('Winner Selected');
    },
    restartBracket() {
              $( "#submitFinal").addClass( "loading" );
              location.reload();
            },
    submitFinal() {
              $( "#submitFinal").addClass( "loading" );
              axios.put(this.route, {
                results: this.submitarray
              }).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            },
  }
};
</script>
